import GenerateQR from "@/views/admin/qr/GenerateQR";

export default {
  path: "tables-qr/generate-qr",
  name: "GenerateQR",
  component: GenerateQR,
  props: true,
  meta: {
    requiresAuth: true
  }
};
